/**
 * ML-1 — Transloco root configuration.
 *
 * Minimal setup for the multi-language foundation:
 *   - Supported languages: "en" (default), "ar"
 *   - JSON translation files served from /i18n/{lang}.json (in /public)
 *   - Single shared scope — feature scopes deferred to later phases
 *
 * ML-2+ will translate POS+KDS, ML-5 will sweep component-level RTL.
 * ML-1 only proves the stack works on a handful of strings inside the
 * tenant + platform shells.
 */
import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import {
  provideTransloco,
  Translation,
  TranslocoLoader,
} from '@jsverse/transloco';

export class TranslocoHttpLoader implements TranslocoLoader {
  private readonly http = inject(HttpClient);

  getTranslation(lang: string) {
    return this.http.get<Translation>(`/i18n/${lang}.json`);
  }
}

export const provideTranslocoRoot = () =>
  provideTransloco({
    config: {
      availableLangs: ['en', 'ar'],
      defaultLang: 'en',
      fallbackLang: 'en',
      reRenderOnLangChange: true,
      prodMode: false,
    },
    loader: TranslocoHttpLoader,
  });
